import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const CampusWaste = (props) => {
    const width = props.width ? props.width + 'px' : '58px';
    const height = props.height ? props.height + 'px' : '33px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 58 33"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.4645 22.5405C31.6097 22.5405 33.6198 21.9367 35.328 20.8879L39.2808 24.8407L41.4856 22.6359L37.7474 18.8977C39.5946 16.8875 40.7268 14.21 40.7268 11.2703C40.7268 5.05712 35.6737 0 29.4645 0C23.2553 0 18.2021 5.05712 18.2021 11.2703C18.2021 17.4834 23.2553 22.5405 29.4645 22.5405ZM29.4645 3.11849C33.9575 3.11849 37.6123 6.77726 37.6123 11.2703C37.6123 15.7633 33.9575 19.4221 29.4645 19.4221C24.9715 19.4221 21.3167 15.7633 21.3167 11.2703C21.3167 6.77726 24.9715 3.11849 29.4645 3.11849Z"
            />
            <path d="M58 28.2607H0V32.1407H58V28.2607Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M50.0426 14.3369L45.2676 25.5754H48.4616L51.2742 18.9451L54.0907 25.5754H57.2847L52.5096 14.3369H50.0426Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M51.1873 12.3348C54.5362 12.3348 57.2574 9.59764 57.2574 6.22887C57.2574 2.8601 54.5362 0.126953 51.1873 0.126953C47.8384 0.126953 45.1211 2.86408 45.1211 6.23284C45.1211 9.60161 47.8423 12.3387 51.1873 12.3387V12.3348ZM51.1873 3.10243C52.9034 3.10243 54.2978 4.50476 54.2978 6.22887C54.2978 7.95298 52.9034 9.35531 51.1873 9.35531C49.4711 9.35531 48.0807 7.95298 48.0807 6.22887C48.0807 4.50476 49.4751 3.10243 51.1873 3.10243Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.19409 12.3348C10.543 12.3348 13.2642 9.59764 13.2642 6.22887C13.2642 2.8601 10.539 0.126953 7.19409 0.126953C3.84916 0.126953 1.12793 2.86805 1.12793 6.23284C1.12793 9.59764 3.84916 12.3387 7.19409 12.3387V12.3348ZM7.19409 3.10243C8.91026 3.10243 10.3046 4.50476 10.3046 6.22887C10.3046 7.95298 8.91026 9.35531 7.19409 9.35531C5.47793 9.35531 4.08752 7.95298 4.08752 6.22887C4.08752 4.50476 5.4819 3.10243 7.19409 3.10243Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.98723 25.5081H5.94682V16.8319H8.44558V25.5081H11.4012V16.8319H14.2615V13.8564H0.126953V16.8319H2.98723V25.5081Z"
            />
        </SvgStyled>
    );
};

export default CampusWaste;
